jQuery(document).ready(function() {
  jQuery(".club-floating").hide(); //ボタンを非表示にする
  jQuery(window).on("scroll", function() {
    let scrollTop = jQuery(window).scrollTop(); // スクロール上部の位置
    let areaTop = jQuery(".main").offset().top; // 対象エリアの上部の位置
    let areaBottom = areaTop + jQuery(".main").innerHeight();
    let navTop = jQuery(".slider").offset().top;
    let navBottom = navTop + jQuery(".slider").innerHeight(); // 対象エリアの上部の位置
    scrollHeight = jQuery(document).height(); //ドキュメントの高さ
    if (scrollTop > areaTop && scrollTop < areaBottom) {
      jQuery(".club-floating").fadeIn(); //ボタンがフェードインする
    } else {
      jQuery(".club-floating").fadeOut(); //ボタンがフェードアウトする
    }

    if (scrollTop > navBottom) {
      jQuery(".fix-header").addClass("js-fixed");
    } else {
      jQuery(".fix-header").removeClass("js-fixed");
    }

    scrollPosition = jQuery(window).height() + jQuery(window).scrollTop(); //現在地
    footHeight = jQuery("footer").innerHeight(); //止めたい位置の高さ(今回はfooter)
    stopHeight = footHeight;
    if (scrollHeight - scrollPosition <= stopHeight) {
      //ドキュメントの高さと現在地の差がfooterの高さ以下の時
      jQuery(".club-floating").css({
        position: "absolute" //pisitionをabsoluteに変更
      });
    } else {
      //それ以外の場合は
      jQuery(".club-floating").css({
        position: "fixed" //固定表示
      });
    }
  });
});

/*----------------------------------------------------------------------*/
/*タブメニュー
/*----------------------------------------------------------------------*/
jQuery(function() {
  //.prefectures_tab liをクリックしたとき
  jQuery(".prefectures_tab li._item").on("click", function() {
    //クリックされた.prefectures_tab liを特定する
    var index = jQuery(".prefectures_tab li._item").index(this);

    //.prefectures_list liにはあらかじめdisplay:noneを効かせておく
    jQuery(".prefectures_list li").css("display", "none");
    //クリックされた.prefectures_list liを.eq(index)で探しだし、display:blockを効かせる
    jQuery(".prefectures_list li")
      .eq(index)
      .css("display", "block");

    //クリックされた.prefectures_tab liにはclass名selectを付け、他のものには付けない。
    jQuery(".prefectures_tab li._item").removeClass("select");
    jQuery(this).addClass("select");
  });
});

// ローディング判定
jQuery(window).on("load", function() {
  jQuery(function() {
    let swipeOption = {
      loop: true,
      effect: "fade",
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      preloadImages: false,
      lazy: {
        loadPrevNext: true
      },
      speed: 1500,
      pagination: {
        el: ".swiper-pagination", //ページネーションの要素
        type: "bullets", //ページネーションの種類
        clickable: true //クリックに反応させる
      },
      navigation: {
        nextEl: ".swiper-button-next", // 「次へ」ボタン要素のクラス
        prevEl: ".swiper-button-prev" // 「前へ」ボタン要素のクラス
      }
    };
    new Swiper(".swiper", swipeOption);
  });
});
